import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableGraphicManagerManifestContent from './tableGraphicManagerManifestContent';

export default {
  title: 'Graphic resource for VOD content',
  attributeName: 'graphicManagerNewResource',
  fields:[
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Interactable graphic name',
      label: 'Name',
      required: true,
      helpText: 'Name of the content',
      errorText: '',
    },
    {
      attributeName: 'tags',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Tags',
      label: 'Tags',
      required: true,
      helpText: 'Tags',
      errorText: '',
    },
    {
      attributeName: 'url_id',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'URL',
      helpText: 'Any valid url for this resource.',
      placeholder: 'Valid url to include',
      fileType: [''],
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'size',
      helpText: 'Size',
      type: FormInputTypes.SELECT,
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      label: 'Size',
      placeholder: 'Please select the desirable size',
      multiple: false,
      options:[
        { name: 'XXL', value: 'xxl' },
        { name: 'XL-V', value: 'xlv' },
        { name: 'XL-H', value: 'xlh' },
        { name: 'L-V', value: 'lv' },
        { name: 'L-H', value: 'lh' },
        { name: 'M', value: 'm' },
        { name: 'S-V', value: 'sv' },
        { name: 'S-H', value: 'sh' },
        { name: 'XS', value: 'xs' },
        
      ]
    },
    {
      attributeName: 'radius',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Radius',
      label: 'Radius',
      required: true,
      helpText: 'Radius',
      errorText: '',
    },
    {
      attributeName: 'horizontalAngle',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Horizontal Angle',
      label: 'Horizontal angle',
      required: true,
      helpText: 'Horizontal angle',
      errorText: '',
    },
    {
      attributeName: 'verticalAngle',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Vertical angle',
      label: 'Vertical angle',
      required: true,
      helpText: 'Vertical angle',
      errorText: '',
    },  
    {
      attributeName: 'whiteListDomains',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Add here the domains separated with commas, and no https and no www',
      label: 'Whitelisted domains',
      required: true,
      multiline:true,
      helpText: 'Type here the valid domains you allow in the webview',
      errorText: '',
    },

    {
      attributeName: 'navBar',
      helpText: 'Has this interactable a nav bar to navigate?.',
      label: 'Navigation bar',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    
  ],
 
};
